export default function initLangSelect() {
    const selects = document.querySelectorAll('.js-lang-select');
    if (!selects.length) return;

    selects.forEach((el) => {
        if (el.dataset.langBound === '1') return;

        el.addEventListener('change', (e) => {
            const select = e.currentTarget;
            const opt = select.selectedOptions?.[0];
            const url = select.value;

            if (!opt || opt.disabled || !url) return;

            window.location.href = url;
        });

        el.dataset.langBound = '1';
    });
}
